import React, { JSX } from 'react';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type PullQuoteProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    QuoteDescription: Field<string>;
  };
};
const PullQuote = (props: PullQuoteProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`pull-quote-${props.rendering?.uid}`}
    >
      <div className="jss-inner-container">
        <div className="pull-quote bg-color-base shadow">
          <div className="full-inner-spacing">
            <RichText
              className="quote"
              tag="h2"
              field={fields?.QuoteDescription}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PullQuote;
